import styled from 'styled-components';

export const ModalText = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors['neutral-90']};
`;
